var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.25V6.375C3 4.51104 4.51104 3 6.375 3C8.23898 3 9.75 4.51104 9.75 6.375V11.625C9.75 12.6605 10.5895 13.5 11.625 13.5C12.6605 13.5 13.5 12.6605 13.5 11.625V6.62197C12.6261 6.3131 12 5.47967 12 4.5C12 3.25736 13.0073 2.25 14.25 2.25C15.4927 2.25 16.5 3.25736 16.5 4.5C16.5 5.47967 15.8739 6.3131 15 6.62197V11.625C15 13.489 13.489 15 11.625 15C9.76102 15 8.25 13.489 8.25 11.625V6.375C8.25 5.33947 7.41053 4.5 6.375 4.5C5.33947 4.5 4.5 5.33947 4.5 6.375V11.25H6.75L3.75 15L0.75 11.25H3Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDirection);
export default __webpack_public_path__ + "static/media/map-direction.1587a81ba1f1a8ed9c82d35034e75ab1.svg";
export { ForwardRef as ReactComponent };